import { render, staticRenderFns } from "./trade-walk.vue?vue&type=template&id=e72479a2&"
import script from "./trade-walk.vue?vue&type=script&lang=js&"
export * from "./trade-walk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports